<script lang="ts">
	import { onMount } from 'svelte';
	import Facet from './Facet.svelte';

	import {
		from,
		to,
		min,
		max,
		totalHits,
		hits,
		selectedObjectTypes,
		selectedArtistTitles,
		selectedArtistCountries,
		selectedAwardYears,
		selectedAwardCountries,
		filtered,
		searchParams,
		query,
		filter,
		resetAll,
		page,
		totalPages,
		getSessionInfo,
	} from '../stores/filter';
	import { writable } from 'svelte/store';
	import ActiveFilters from './ActiveFilters.svelte';
	import { captureException } from '@sentry/browser';

	let { labels } = $props();

	let facetDistribution = $state<FacetDistribution>({});

	$effect(() => window.history.replaceState({}, '', `?${$searchParams}`));

	let session: Record<string, string>;
	let isInitialized = writable(false);

	onMount(async () => {
		session = await getSessionInfo();
		const response = await fetch(
			'/actions/site-module/search/search-artworks',
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'X-CSRF-Token': session.csrfTokenValue,
					'X-Requested-With': 'XMLHttpRequest',
				},
			},
		);

		const json = await response.json();

		facetDistribution = json.facetDistribution;

		$totalHits = json.totalHits;

		const years = Object.keys(json.facetDistribution.years);
		$min = parseInt(years[0]);
		$max = parseInt(years[years.length - 1]);
		if (!$from) {
			$from = $min;
		}
		if (!$to) {
			$to = $max;
		}
		$isInitialized = true;
	});

	$effect(() => {
		if ($isInitialized && $searchParams) {
			search();
		}
	});

	let timeout: ReturnType<typeof setTimeout>;
	let controller: AbortController;

	const search = async () => {
		controller?.abort();
		clearTimeout(timeout);

		timeout = setTimeout(async () => {
			controller = new AbortController();
			const signal = controller.signal;

			try {
				const response = await fetch(
					'/actions/site-module/search/search-artworks',
					{
						method: 'POST',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
							'X-CSRF-Token': session.csrfTokenValue,
							'X-Requested-With': 'XMLHttpRequest',
						},
						body: JSON.stringify({
							page: $page,
							query: $query,
							...$filter,
						}),
						signal,
					},
				);

				const json = await response.json();

				const newFacetDistribution = Object.entries(facetDistribution)
					.map(([facet, options]) => {
						const updatedFacet = Object.entries(options).map(
							([option, num]) => {
								if (facet === 'years' && ($from !== $min || $to !== $max)) {
									return { [option]: num };
								}
								/*
          if (facet === "objectType" && $selectedObjectTypes.length) {
            return { [option]: num };
          }
          if (facet === "artists.name" && $selectedArtistTitles.length) {
            return { [option]: num };
          }
          if (facet === "artists.countryOfBirth" && $selectedArtistCountries.length) {
            return { [option]: num };
          }
          if (facet === "awards.year" && $selectedAwardYears.length) {
            return { [option]: num };
          }
          */
								return { [option]: json.facetDistribution[facet][option] ?? 0 };
							},
						);
						return {
							[facet]: updatedFacet.reduce(
								(acc, curr) => Object.assign(acc, curr),
								{},
							),
						};
					})
					.reduce((acc, curr) => Object.assign(acc, curr), {});

				facetDistribution = newFacetDistribution;

				$totalHits = json.totalHits;
				$hits = json.hits;
				$totalPages = json.totalPages;
			} catch (err) {
				captureException(err);
			}
		}, 500);
	};
</script>

<div class="filter__inner">
	<div class="filter__subgrid">
		<Facet
			title={labels.objectType}
			name="objectTypes[]"
			options={facetDistribution.objectType}
			bind:selectedItems={$selectedObjectTypes}
		/>
		{#if $max && $min}
			<Facet
				title={labels.period}
				mode="range"
				options={facetDistribution.years}
			/>
		{/if}
	</div>
	<Facet
		title={labels.artists}
		name="artistTitles[]"
		options={facetDistribution['artists.title']}
		bind:selectedItems={$selectedArtistTitles}
	/>
	<Facet
		title={labels.nationality}
		name="artistCountries[]"
		options={facetDistribution['artists.countryOfBirth']}
		bind:selectedItems={$selectedArtistCountries}
	/>
	<Facet
		title={labels.artAward}
		name="awardYears[]"
		options={facetDistribution['awards.year']}
		bind:selectedItems={$selectedAwardYears}
	/>
	<Facet
		title={labels.participatingCountries}
		name="awardCountries[]"
		options={facetDistribution['awards.country']}
		bind:selectedItems={$selectedAwardCountries}
	/>

	<div class="filter__subgrid">
		<div class="filter__results">
			<div class="filter__heading">
				{$totalHits}
				{$totalHits === 1 ? labels.result : labels.results}
			</div>
			{#if $filtered}
				<ActiveFilters />
			{/if}
		</div>
		<div class="filter__submit">
			<button
				type="button"
				class="button submit"
				onclick={document.querySelector('dialog#filter')?.close()}
				>{labels.apply}</button
			>
			{#if $filtered}
				<button type="button" class="reset" onclick={resetAll}
					>{labels.clear}</button
				>
			{/if}
		</div>
	</div>
</div>
